import React, { Suspense, lazy } from 'react'
import { HashRouter as Router, Routes, Route } from 'react-router-dom'


import Navbar from './components/Navbar'
import SideNav from './components/SideNav'
import Footer from './components/Footer'
import Preloader from './components/Preloader'


const HomePage = lazy(() => import('./pages/HomePage'));
const VirtualWaterPlotCountries = lazy(() => import('./pages/VirtualWaterPlotCountries'));
const VirtualWaterPlotSectors = lazy(() => import('./pages/VirtualWaterPlotSectors'));




const App = () => {
  return (
    <div>
      <Router>
        <Navbar />

        <div className='dashboard_container_main'>
        <SideNav />

        <Suspense fallback={<Preloader />}>
 
          <Routes>
            <Route path='/' element={<HomePage />} />
            <Route path='/countries-vw' element={<VirtualWaterPlotCountries />} />
            <Route path='/sectors-vw' element={<VirtualWaterPlotSectors />} />
            {/* <Route path='/water-matrix' element={<VirtualWaterPage />} /> */}
          </Routes>
          </Suspense>
    

        </div>

        {/* <Footer/> */}

      </Router>

    </div>
  )
}

export default App
